import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Gift } from "lucide-react";

let cache = null;
export default function ShareEarnHint({ testid = "share-earn", compact = false }) {
  const [d, setD] = useState(cache);
  useEffect(() => { if (!cache) api.get("/share-rewards/me").then(({ data }) => { cache = data; setD(data); }).catch(() => {}); }, []);
  if (!d || d.reward_blc <= 0) return null;
  return (
    <span data-testid={testid} title="Share any item with its Share button. When a friend buys through your link, you earn bonus BLC."
      className={`inline-flex items-center gap-1.5 border border-amber-400/50 bg-amber-400/10 text-amber-300 font-black uppercase tracking-widest ${compact ? "text-[9px] px-2 py-0.5" : "text-[10px] px-2.5 py-1"}`}>
      <Gift className={compact ? "w-3 h-3" : "w-3.5 h-3.5"} /> Share & earn {Number(d.reward_blc)} BLC
      {d.earned > 0 && <span className="text-white/80 normal-case tracking-normal">· you&apos;ve earned {Number(d.earned)}</span>}
    </span>
  );
}
